/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOPTimeOut from './pre-op-time-out';
import PreOPTimeOutDetail from './pre-op-time-out-detail';
import PreOPTimeOutUpdate from './pre-op-time-out-update';
import PreOPTimeOutDeleteDialog from './pre-op-time-out-delete-dialog';

const PreOPTimeOutRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOPTimeOut />} />
    <Route path="new" element={<PreOPTimeOutUpdate />} />
    <Route path=":id">
      <Route index element={<PreOPTimeOutDetail />} />
      <Route path="edit" element={<PreOPTimeOutUpdate />} />
      <Route path="delete" element={<PreOPTimeOutDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOPTimeOutRoutes;
